'use client';

import Link from 'next/link';
import { Button } from 'rizzui';
import { ArrowRight, ArrowUpRight } from 'lucide-react';

export function QuoteLink({
  href,
  process = false,
}: {
  href: string;
  process?: boolean;
}) {
  return (
    <Link
      className={process ? 'fb-quote fb-quote--process' : 'fb-quote'}
      href={href}
    >
      <Button as="span" className="fb-quote__button" rounded="pill">
        {process ? 'Request A Quote' : 'Get a Freight Quote'}
        {process ? null : <ArrowUpRight size={17} aria-hidden="true" />}
      </Button>
      {process ? (
        <span className="fb-quote__circle" aria-hidden="true">
          <ArrowRight size={22} />
        </span>
      ) : null}
    </Link>
  );
}
